import { ChartData } from './chart-data';

export interface ChatMessage {
  type: ChatMessageType;
  content: string | ChartData;
  role: ChatMessageRole;
}

export enum ChatMessageType {
  MARKDOWN = 'md',
  CHART = 'chart',
  TEXT = 'text'
}

export enum ChatMessageRole {
  USER = 'user',
  AGENT = 'agent',
  SYSTEM = 'system'
}

export enum ChartType {
  LINE = 'line',
  PIE = 'pie',
  BAR = 'bar',
  GROUPED_BAR = 'groupedBar'
}